import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't save auth/utility pages as last path
    const EXCLUDED = ["/", "/login", "/forgot-password"];
    const isExcluded = EXCLUDED.includes(location.pathname) || location.pathname.startsWith("/changepassword/");
    if (!isExcluded && location.pathname.length > 1) {
      localStorage.setItem("last_path", location.pathname + location.search);
    }
  }, [location]);

  return null; // Invisible component
};

export default RouteTracker;
